/**
 * ROLLBREAK UI Kit — Dark Fantasy RPG palette (author test assets).
 * Visual chrome only; never invent progression / economy values.
 */

export const UI: Record<string, number> = {
  bgDeep: 0x0e0c12,
  bgPanel: 0x1a1624,
  bgRecess: 0x12101a,
  bgStone: 0x2a2438,
  iron: 0x3a3348,
  ironLight: 0x5a5368,
  gold: 0xd4a017,
  goldBright: 0xf0c040,
  goldDim: 0x8a6a20,
  parchment: 0xe8d5a3,
  parchmentDim: 0xb8a878,
  textMuted: 0x8a8498,
  textBody: 0xd0c8e0,
  cyan: 0x4ec8e8,
  ruby: 0xc04050,
  emerald: 0x3a9a60,
  amethyst: 0x8a5ab8,
  cobalt: 0x3a5a9a,
  burnt: 0xc06828,
  townPath: 0x4a3828,
};

/** Display / titles — Cinzel (bundled OFL). */
export const FONT_DISPLAY = 'Cinzel, Georgia, serif';
/** Body / UI labels — Karla (bundled OFL). */
export const FONT_UI = 'Karla, "Segoe UI", sans-serif';

export function hexColor(n: number): string {
  return `#${n.toString(16).padStart(6, '0')}`;
}
